import React from 'react';
import { COLORS } from '@constants';
import { Icon, Typography } from '@ui';
import { formatPrice } from '@utils';
import { Flex, Table } from 'antd';
import dayjs from 'dayjs';
import Status from '../components/Status';

export const getColumns = (onDownload) => [
    Table.EXPAND_COLUMN,
    {
        title: <span data-e2e='invoices_charges-date_column'>Date</span>,
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (value, record) => (
            <span data-e2e={`invoices_charge-${record.id}-date_value`}>{dayjs(value).format('ddd, MMM Do, YYYY')}</span>
        )
    },
    {
        title: <span data-e2e='invoices_charges-invoice-number_column'>Invoice number</span>,
        dataIndex: 'sequenceNumber',
        width: '15%',
        align: 'right',
        key: 'sequenceNumber',
        render: (value, record) => <span data-e2e={`invoices_charge-${record.id}-invoice-number_value`}>{value}</span>
    },
    {
        title: <span data-e2e='invoices_charges-status_column'>Status</span>,
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: '15%',
        render: (status, record) => <Status status={status} record={record} />
    },
    {
        title: <span data-e2e='invoices_charges-amount_column'>Amount</span>,
        dataIndex: 'amount',
        key: 'amount',
        width: '15%',
        align: 'right',
        render: (amount, record) => {
            const amountAfterRefunds = record.refunded ? amount - record.refunded : amount;
            return (
                <Flex vertical align='flex-end'>
                    <span data-e2e={`invoices_charge-${record.id}-amount_value`}>
                        {formatPrice(amountAfterRefunds)}
                    </span>
                    {record.refunded ? (
                        <Typography.Text type='descriptor2' color={COLORS.$gray40Black}>
                            (refunded {formatPrice(record.refunded)})
                        </Typography.Text>
                    ) : null}
                </Flex>
            );
        }
    },
    {
        title: <span>PDF download</span>,
        dataIndex: 'pdfDownload',
        key: 'pdfDownload',
        align: 'right',
        render: (_, record) => (
            <Icon
                data-e2e={`invoices_charge-${record.id}-download-pdf_btn`}
                onClick={() =>
                    onDownload({
                        report_id: record.id,
                        report_updated_at: record.updatedAt
                    })
                }
                cursor='pointer'
                size='24px'
                color={COLORS.$gray60Black}
                component={() => <Icon.DownloadIcon />}
            />
        )
    }
];
